import Counter from "@/shared/components/common/counter";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import type { MinPriceRoom } from "@/types/services/hotel/apis/Detail";

interface RoomCardCounterProps {
  room: MinPriceRoom;
  countRooms: (count: number) => void;
  currentRoomCount: number;
  totalRoomCount: number;
  limit: number;
}

export default function RoomCardCounter(props: RoomCardCounterProps) {
  const { room, countRooms, currentRoomCount, totalRoomCount, limit } = props;

  return (
    <Counter
      classNames={{
        parent: "animate-fade-in w-full justify-between",
      }}
      orientation="horizontal"
      format={(count) => `${count} اتاق`}
      buttonPlaceHolders={{
        icons: {
          decrease: (
            <PhosphorIcon
              name="MinusCircle"
              weight="fill"
              className="w-9! h-9! text-primary"
            />
          ),
          increase: (
            <PhosphorIcon
              name="PlusCircle"
              weight="fill"
              className="w-9! h-9! text-primary"
            />
          ),
        },
      }}
      limit={room.rate_plans.inventory}
      initial={currentRoomCount}
      disable={{
        decrease: currentRoomCount === 0 || totalRoomCount === 0,
        increase:
          totalRoomCount >= limit ||
          room.rate_plans.inventory === currentRoomCount,
      }}
      onCount={countRooms}
    />
  );
}
